import { NavItemSchema } from '@shared/interfaces/nav/nav-item-schema';

/**
 * Generates navigation items based on a provided schema, replacing placeholders in route templates with specific values.
 *
 * @param {NavItemSchema[]} schema - An array of navigation item schemas, where each schema includes a title and a route template.
 * @param {string} paramKey - The key associated with placeholders in the route template that need to be replaced.
 * @param {T} paramValue - The value to substitute for placeholders matching the paramKey in the route template.
 * @return {Array<{title: string, route: string[]}>} An array of navigation items, with each item containing a title and a resolved route array.
 */
export function generateNavItems<T extends string | number>(
  schema: NavItemSchema[],
  paramKey: string,
  paramValue: T
): Array<{title: string, route: string[]}> {
  return schema.map(item => ({
    title: item.title,
    route: item.routeTemplate.map(routePart => {
        return routePart === `{${paramKey}}` ? String(paramValue) : routePart;
      }
    )
  }));
}
